"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWorkflowPreferencesFromPreferenceChannels = exports.buildWorkflowPreferences = void 0;
const consts_1 = require("../consts");
const types_1 = require("../types");
/**
 * Given any partial input of preferences, output a complete preferences object that:
 * - First uses channel-level preferences
 * - Uses the workflow-level preference as defaults for channel preferences if not specified
 * - Lastly, uses the defaults we've defined
 */
const buildWorkflowPreferences = (inputPreferences, defaultPreferences = consts_1.DEFAULT_WORKFLOW_PREFERENCES) => {
    if (!inputPreferences) {
        return defaultPreferences;
    }
    const defaultChannelPreference = {
        // Only use the workflow-level enabled preference if defined
        ...(inputPreferences?.all?.enabled !== undefined ? { enabled: inputPreferences.all.enabled } : {}),
    };
    return {
        ...defaultPreferences,
        all: {
            ...defaultPreferences.all,
            ...inputPreferences.all,
        },
        channels: {
            ...defaultPreferences.channels,
            ...Object.values(types_1.ChannelTypeEnum).reduce((output, channel) => ({
                ...output,
                [channel]: {
                    ...defaultPreferences.channels[channel],
                    ...defaultChannelPreference,
                    ...inputPreferences?.channels?.[channel],
                },
            }), {}),
        },
    };
};
exports.buildWorkflowPreferences = buildWorkflowPreferences;
/**
 * Given a `critical` flag and a `IPreferenceChannels` object, build a `WorkflowPreferences` object
 *
 * @deprecated use `buildWorkflowPreferences` instead
 */
const buildWorkflowPreferencesFromPreferenceChannels = (critical = false, preferenceChannels = {}) => {
    return (0, exports.buildWorkflowPreferences)({
        all: { enabled: true, readOnly: critical },
        channels: Object.entries(preferenceChannels).reduce((output, [channel, value]) => ({
            ...output,
            [channel]: {
                enabled: value,
            },
        }), {}),
    });
};
exports.buildWorkflowPreferencesFromPreferenceChannels = buildWorkflowPreferencesFromPreferenceChannels;
//# sourceMappingURL=buildWorkflowPreferences.js.map